import React, { useEffect, useState } from 'react';
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import Profile from '../../components/profile';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import provincess from '../../provinces';
import Alert from "../../components/Alert";
import LoadingScreen from '../../components/LoadingScreen';
import Notification from '../../components/Notification';
import Trolly from '../../components/Trolly';

import Stack from '@mui/material/Stack';
import "../../css/profile.css"


export default function ProfilePage() {
  const [cookies, setCookie] = useCookies(['accessToken']);
  const [userData, setUser] = React.useState({});
  const [urlImg, setUrlImg] = React.useState('');
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [alertActive, setAlertActive] = useState(true);
  const [alert, setAlert] = useState({});
  const [image, setImage] = useState(' ');
  const [nama, setNama] = useState(' ');
  const [noHp, setNoHp] = useState(' ');
  const [provinc, setProvinc] = useState('Pilih');
  const [address, setAddress] = useState(' ');

  const activateAlert = () => {
    setAlertActive(true);
    setTimeout(() => {
      setAlertActive(false);
    }, 3000);
  };

  useEffect(() => {
    setUrlImg(userData.imgUrl)
  }, [userData.imgUrl]);

  const uploadImage = async (image) => {
    setIsLoading(true)
    const url = 'https://w-shop-backend.vercel.app/api/images?type=PROFILE_IMG';
    const form = new FormData();
    form.append('image', image);
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + cookies.accessToken,
      },
      body: form,
    })
    const body = await response.json();
    setUrlImg(body.data.imageUrl)
    setIsLoading(false)
    return body.data;
  }

  const handleUpdate = async () => {
    setIsLoading(true);
    try {
      let imageData = {}
      if (image !== ' ') {
        imageData = await uploadImage(image);
      } else {
        imageData = { imageUrl: userData.imgUrl, imageId: userData.imgId }
      }
      let namee = (nama !== ' ' ? nama : userData.name)
      let phoneNumberr = (noHp !== ' ' ? noHp : userData.phoneNumber)
      let addresss = (address === ' ' ? userData.address : address)
      let provincess = (provinc !== 'Pilih' ? provinc : userData.provinces)
      const data = {
        imgId: imageData.imageId,
        imgUrl: imageData.imageUrl,
        name: namee,
        phoneNumber: phoneNumberr,
        provinces: provincess,
        address: addresss
      };
      const url = 'https://w-shop-backend.vercel.app/api/users/';
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-type': 'application/json',
          'Authorization': 'Bearer ' + cookies.accessToken,
        },
        body: JSON.stringify(data),
      });
      const body = await response.json();
      if (body.status !== 'success') {
        throw new Error(body.message,);
      } else {
        const event = {
          type: 'alert',
          alert: {
            type: 'success',
            message: 'Update Ticket Data Success',
          }
        };
        setCookie('event', event, { path: '/' });
        setAlert(event.alert)
        activateAlert()
        navigate('/home');
        setIsLoading(false)
      }
    } catch (error) {
      setIsLoading(false);
      setAlert({
        type: 'danger',
        message: 'Error: ' + error.message,
      })
      activateAlert();
    }
  }

  const UploadButtons =
    <Stack direction="row" alignItems="center" spacing={2} style={{ display: "block", width: 210 }}>
      <Button variant="contained" component="label">
        Pilih Gambar <img alt="" src="/img/camera.png" className="ms-3" style={{ width: "30px" }}></img>
        <input hidden accept="image/*" multiple type="file" onChange={(e) => {
            setImage(e.target.files[0])
            setUrlImg(URL.createObjectURL(e.target.files[0]))
          }} />
      </Button>
    </Stack>
  return (
    <div>
      <Alert active={alertActive} type={alert.type} message={alert.message} />
      <LoadingScreen active={isLoading} />
      <Navbar userData={setUser} logReg={<Profile userData={userData}/>} notification={<Notification />} trolly={<Trolly />} />
      <div className='main'>
        <div className='container py-5'>
          <div className=' p-5' style={{ backgroundColor: "white" }}>
            <h1 className=' titleProfile'>Profile</h1>
            <hr />
            <div className='row'>
              <div className=' col-12 col-lg-7 border-end'>
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <p>{userData.email} <a href='/updateEmail' className=' ms-2'>Ubah</a></p>
                </div>
                <div className="mb-3">
                  <label className="form-label">Password</label>
                  <a href='/updatePassword' className=' d-block'>Ubah</a>
                </div>
                <div className="mb-3">
                  <label className="form-label">Nama</label>
                  <input type="text" className="form-control" id="nama" defaultValue={userData.name} onChange={(e) => {
                    setNama(e.target.value);
                  }} />
                </div>
                <div className="mb-3">
                  <label className="form-label">No Hp</label>
                  <input type="number" className="form-control" id="noHp" defaultValue={userData.phoneNumber} onChange={(e) => {
                    setNoHp(e.target.value);
                  }} />
                </div>
                <h1 className='alamat'>Alamat</h1>
                <div className="mb-3">
                  <label className="form-label">Provinsi</label>
                  <select className="form-select" onChange={(e) => {
                    setProvinc(e.target.value);
                  }}>
                    <option hidden>{userData.provinces}</option>
                    {provincess.map((prov) => (
                      <option key={prov.id} value={prov.name}>{prov.name}</option>
                    ))
                    }
                  </select>

                </div>
                <div className="mb-3">
                  <label className="form-label">Jalan, rt/rw no, Kelurahan, Kecamatan, Kota</label>
                  <input type="text" className="form-control" id="kecamatan" defaultValue={userData.address} onChange={(e) => {
                    setAddress(e.target.value);
                  }} />
                </div>
              </div>
              <div className=' col-12 col-lg-5 text-center'>
                <img alt='' src={urlImg} className=' imgProfile p-5 d-block ms-auto me-auto mb-5 ' />
                <div className=' d-block ms-auto me-auto ' style={{ width: 215 }} >
                  {UploadButtons}
                </div>
                <label className='desga d-block mt-1'>Ukuran gambar : maks 1 mb</label>
                <label className='desga'>Format gambar : JPG, PNG</label>
                <button className="btn btn-primary  ms-auto  d-block" style={{ width: '180px', marginTop: '15%', height: '50px' }} onClick={handleUpdate}>Simpan</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
